import { Component, Prop, PropSync, Watch } from 'vue-property-decorator';
import DsModal from '@/shared/modal/ds-modal.vue';
import { Vue } from 'vue-property-decorator';

@Component({
  components: { DsModal },
})
export default class AccountTwitterModeComponent extends Vue {
  @Prop({ type: Boolean, required: true }) open!: boolean;
  @Prop({ type: Object, default: () => ({}) }) userEdit!: any;
  @Prop({ type: Array, required: false }) sourceCacheList!: any;
  @Prop({ type: Array, required: false }) dataSourceSetting!: any;
  @PropSync('channelConnect', { type: Object }) syncedChannelConnect!: any;
  showModal = this.open;
  channelConnect: any;
  invalidUrl = false;
  isDisableBtn = true;
  invalidProfile = false;

  formData = {
    profile: false,
    urlProfile: null,
    keyword: null,
  } as any;

  @Watch('formData', { deep: true })
  onFormDataChange(value: any) {
    if (!value.profile && !value.urlProfile && (!value.keyword || value.keyword.trim() === '')) {
      this.isDisableBtn = true;
      return;
    }

    if (value.urlProfile && value.urlProfile.trim() !== '') {
      const regex = /^https?:\/\/(?:www\.)?(?:twitter\.com|x\.com)\/([a-zA-Z0-9_]+)$/;
      const match = value.urlProfile.match(regex);
      this.invalidProfile = !match;

      if (!match) {
        this.isDisableBtn = true;
        return;
      }
    }

    this.isDisableBtn = false;
  }

  @Watch('open')
  async onOpenChange(value: boolean) {
    this.showModal = value;
    this.isDisableBtn = true;
    this.formData = {
      profile: false,
      urlProfile: null,
      keyword: null,
    } as any;
    if (this.dataSourceSetting.length > 0 || this.sourceCacheList.length > 0) {
      console.log(this.sourceCacheList, 'sourceCacheList');
      const target = this.dataSourceSetting.find(item => item.accountId === this.userEdit.accountId && item.channelType === 'X_TWITTER');
      if (target && Array.isArray(target.collections)) {
        target.collections.forEach(collection => {
          if (Array.isArray(collection.datasourceList)) {
            collection.datasourceList.forEach(ds => {
              if (Array.isArray(ds.dataSourceTypes) && ds.dataSourceTypes.length > 0) {
                if (ds.dataSourceTypes[0] === 'MY_PROFILE') {
                  this.formData.profile = true;
                } else if (ds.dataSourceTypes[0] === 'PROFILE') {
                  this.formData.urlProfile = ds.value[0];
                } else if (ds.dataSourceTypes[0] === 'KEYWORD') {
                  this.formData.keyword = ds.value[0];
                }
              }
            });
          }
        });
      }
      const matchedChannel = this.sourceCacheList.find(
        channel => channel.channelType === 'X_TWITTER' && channel.accounts?.[0]?.accountId === this.userEdit.accountId
      );

      if (matchedChannel) {
        const dataSources = matchedChannel.accounts[0].dataSource;
        dataSources.forEach(ds => {
          if (ds.dataSourceTypes[0] === 'MY_PROFILE') {
            this.formData.profile = true;
          } else if (ds.dataSourceTypes[0] === 'PROFILE') {
            this.formData.urlProfile = ds.value[0];
          } else if (ds.dataSourceTypes[0] === 'KEYWORD') {
            this.formData.keyword = ds.value[0];
          }
        });
      }
    } else {
      this.formData = {
        trending: false,
        mySubscription: false,
        ytMyChannel: false,
        ytUrl: null,
        ytKeyword: null,
      } as any;
    }
  }

  generateDataSources(data: any) {
    const dataSources: any = [];
    if (data.profile) {
      dataSources.push({
        value: null,
        dataSourceTypes: ['MY_PROFILE'],
        descriptionEn: 'My Profile',
        dataSourceAccStatus: 1,
      });
    }
    if (data.urlProfile) {
      dataSources.push({
        value: [data.urlProfile],
        dataSourceTypes: ['PROFILE'],
        descriptionEn: 'Profile',
      });
    }
    if (data.keyword) {
      dataSources.push({
        dataSourceTypes: ['KEYWORD'],
        descriptionEn: 'Keyword',
        value: [data.keyword],
      });
    }
    return dataSources;
  }

  async handleSignInSuccess() {
    const value: any = {
      channelId: null,
      channelName: 'X (Twitter)',
      channelDescription: this.formData.channelDescription || '-',
      channelImageUri: 'https://dzh91b51qfr7r.cloudfront.net/social-channel-thumb/twitter.png',
      channelType: this.syncedChannelConnect.channelType,
      allowAccess: 'true',
      accounts: [
        {
          accountId: this.userEdit.accountId,
          accountName: this.userEdit.accountName || '-',
          dataSource: this.generateDataSources(this.formData),
          isScrap: true,
        },
      ],
    };
    this.handleAddX(value);
  }

  handleAddX(value) {
    const accountIds = this.dataSourceSetting
      .filter(item => item.channelType === 'X_TWITTER' && item.accountId)
      .map(item => item.accountId);
    if (accountIds.includes(this.userEdit.accountId)) {
      this.$emit('addItemTwitter', value, true);
    } else {
      this.$emit('addItemTwitter', value, false);
    }
    this.formData = {
      home: false,
      profile: false,
      communities: false,
      urlProfile: null,
      keyword: null,
      urlList: null,
    } as any;
  }

  handleAccessToken() {
    this.handleSignInSuccess().then(r => {});
    this.$emit('modal:close');
  }
}
